import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-copy",
  "use": "icon-copy-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-copy\"><defs><style></style></defs><path d=\"M768 682.667v-512a85.333 85.333 0 00-85.333-85.334h-512a85.333 85.333 0 00-85.334 85.334v512A85.333 85.333 0 00170.667 768h512A85.333 85.333 0 00768 682.667zm-597.333-512h512v512h-512zM853.333 256v512A85.333 85.333 0 01768 853.333H256a85.333 85.333 0 0085.333 85.334H768A170.667 170.667 0 00938.667 768V341.333A85.333 85.333 0 00853.333 256z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol